var portfolioMap = jq('#map');
if (portfolioMap.length) {
    // Locations
    var locations = JSON.parse(document.getElementById('portfolio-map-data').innerHTML) || {};

    // Set Dropdown
    const queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var sector = urlParams.get('sector');
    if (sector) {
        jq('#sector-select').val(escape(sector));
    }
    filterLocations(simplemaps_usmap_mapdata, locations, sector);
    
    jq('#sector-select').change(function(){
        sector = jq(this).val();
        filterLocations(simplemaps_usmap_mapdata, locations, sector);
    });
}
function filterLocations(simplemaps_usmap_mapdata, locations, sector)
{
    simplemaps_usmap_mapdata.locations = {};
    jq.each(locations, function (i, item) {
        if (sector && item.sector != sector) {
            return;
        }
        simplemaps_usmap_mapdata.locations[item.post_id] = { name: item.company, lat: item.lat, lng: item.lng, image_url: item.logo, url: item.url, size: item.height };
    });     
    simplemaps_usmap.load();
    return;
}

// QMOD Quote Page Select
jq('#quote-page-select').on('change', function () {
    var url = jq(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
});